(function () {
  function setupCocreazioneConsent(form) {
    const consent = form.querySelector('[data-cocreazione-consent]');
    const button = form.querySelector('button[data-cocreazione-button]');
    const error = form.querySelector('[data-cocreazione-consent-error]');

    if (!consent || !button) return;

    function updateState() {
      button.disabled = !consent.checked;
    }

    updateState();

    consent.addEventListener('change', () => {
      if (error) error.style.display = 'none';
      updateState();
    });

    form.addEventListener('submit', (e) => {
      if (!consent.checked) {
        e.preventDefault();
        e.stopPropagation();
        if (error) error.style.display = 'block';
        consent.focus();
      }
    });
  }

  function init() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.querySelector('button[data-cocreazione-button]')) {
        setupCocreazioneConsent(form);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();